import { render, staticRenderFns } from "./TableReaders.vue?vue&type=template&id=76e1b602&"
import script from "./TableReaders.vue?vue&type=script&lang=ts&"
export * from "./TableReaders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports